import React from 'react';
import Moment from 'moment';
import { Comment, Image } from 'semantic-ui-react';

export const SpeechBubble = (props) => {
    const { userName, message, createdAt, type } = props.message;
    console.log('props.message', props.message);

    let imageUrl = '/profile_avatar.png';
    if (userName === 'Joey') {
        imageUrl = 'https://incomeapp.mhc.asia/static/app_logo.png';
    }
    else if (props.message.userId === props.user.uuid) {
        imageUrl = props.profilePhoto
    }
    return (
        <Comment>
            <Comment.Avatar src={imageUrl} />
            <Comment.Content>
                <Comment.Author as='a'>{ userName || ''}</Comment.Author>
                <Comment.Metadata>
                    <div>{`${Moment(createdAt).format('DD MMM YYYY hh:mm:ss a')} (${Moment(createdAt).fromNow()})`}</div>
                </Comment.Metadata>
                <div>
                    {
                        type === 1
                        &&
                        <Comment.Text>
                            { message }
                        </Comment.Text>
                    }
                    {
                        type === 2
                        &&
                        <Image size='small' src={ message } href={message} target="_blank"/>
                    }
                </div>

            </Comment.Content>
        </Comment>
    );
}
